import { useState } from "react";
import { C } from "../theme/colors";

export default function StakeholderCard({ s }) {
  const [imgErr, setImgErr] = useState(false);
  return (
    <div className="stk-card" style={{borderTop:`2.5px solid ${s.color}`}}>
      {!imgErr ? (
        <img src={s.img} width="56" height="56" style={{objectFit:"contain"}} alt={s.label} onError={() => setImgErr(true)} />
      ) : (
        <div style={{width:56,height:56,borderRadius:"50%",background:`${s.color}15`,border:`2px solid ${s.color}40`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:24}}>🛡️</div>
      )}
      <span style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:10.5,fontWeight:600,color:C.textMid,textAlign:"center",lineHeight:1.35}}>{s.label}</span>
    </div>
  );
}
